import { gql } from "@apollo/client";

export const CACHE_WAS_RESET = gql`
  subscription cacheWasReset {
    cacheWasReset
  }
`;
